/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type FlashOfferCell_offer$ref: FragmentReference;
declare export opaque type FlashOfferCell_offer$fragmentType: FlashOfferCell_offer$ref;
export type FlashOfferCell_offer = {|
  +id: string,
  +title: string,
  +startDate: any,
  +endDate: any,
  +store: {|
    +name: string
  |},
  +$refType: FlashOfferCell_offer$ref,
|};
export type FlashOfferCell_offer$data = FlashOfferCell_offer;
export type FlashOfferCell_offer$key = {
  +$data?: FlashOfferCell_offer$data,
  +$fragmentRefs: FlashOfferCell_offer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FlashOfferCell_offer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Store",
      "kind": "LinkedField",
      "name": "store",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Offer"
};
// prettier-ignore
(node/*: any*/).hash = '4135aedf9169aa1306c3795ad8fd6bb5';

module.exports = node;
